/**
 * String ids for @dnd-kit: stable droppable ids per grid cell (row + day) and draggable
 * ids per ScopeBar, plus small parsers for debugging or future use.
 */
const PREFIX = "sched-cell|";

/**
 * Stable droppable id for a timeline grid cell (row × calendar day).
 * @param {string} rowId e.g. `project-12` or `group-34`
 * @param {string} dayKey `YYYY-MM-DD`
 * @returns {string}
 */
export function buildScheduleCellDropId(rowId, dayKey) {
  return `${PREFIX}${rowId}|${dayKey}`;
}

/**
 * Parse a cell droppable id back into row + day key.
 *
 * @param {string|import('@dnd-kit/core').UniqueIdentifier} id
 * @returns {{ rowId: string, dayKey: string }|null}
 */
export function parseScheduleCellDropId(id) {
  if (typeof id !== "string" || !id.startsWith(PREFIX)) {
    return null;
  }
  const rest = id.slice(PREFIX.length);
  const pipe = rest.lastIndexOf("|");
  if (pipe === -1) {
    return null;
  }
  return {
    rowId: rest.slice(0, pipe),
    dayKey: rest.slice(pipe + 1),
  };
}

/**
 * Draggable id for a timeline ScopeBar.
 *
 * @param {string|number} barSegmentId Bar render-model id.
 * @returns {string}
 */
export function buildScheduleBarDragId(barSegmentId) {
  return `sched-bar|${barSegmentId}`;
}

/**
 * Parse a ScopeBar draggable id back to the bar segment id.
 *
 * @param {string|import('@dnd-kit/core').UniqueIdentifier} id
 * @returns {string|null} Bar segment id embedded in the draggable id.
 */
export function parseScheduleBarDragId(id) {
  if (typeof id !== "string" || !id.startsWith("sched-bar|")) {
    return null;
  }
  return id.slice("sched-bar|".length);
}
